import type { ActiveUnit } from 'types/active-unit';

/* What the gate form holds, from which the units of a transaction or draft are built. */
export type GateUnitSources = {
  container: ActiveUnit;
  genset: ActiveUnit;
  stack: ActiveUnit[];
  chassis: ActiveUnit;
  location: ActiveUnit['location'];
};

/*
 * The units a gate transaction or draft carries: the container, the genset and the stacked units that
 * were given a unit number, then the chassis the inspector described. Each unit goes out as the form
 * holds it, so a reefer's temperature and humidity keep the decimals that were typed. A unit that was
 * never saved (no id, or a negative placeholder) goes without an id, and every unit takes the location of
 * the move.
 */
export const buildGateUnits = ({ container, genset, stack, chassis, location }: GateUnitSources): ActiveUnit[] => {
  const unitList = [container, genset, ...stack]
    .filter(({ unitNumber }) => !!unitNumber)
    .map(u => ({ ...u, id: (u.id ?? 0) <= 0 ? null : u.id, location })) as ActiveUnit[];

  /* handle flatbed or owner chassis */
  if (chassis.flatbed) {
    unitList.unshift({
      ...chassis,
      unitNumber: chassis.unitNumber ?? 'FLTBDPVT',
      customer: chassis.customer ?? container?.customer ?? genset?.customer ?? stack[0]?.customer
    } as ActiveUnit);
  } else if (chassis.ownerChassis) {
    unitList.unshift({
      ...chassis,
      unitNumber: chassis.unitNumber ?? 'KEEPING',
      customer: chassis.customer ?? container?.customer ?? genset?.customer ?? stack[0]?.customer
    } as ActiveUnit);
  } else if (chassis.unitNumber) {
    unitList.unshift(chassis as ActiveUnit);
  }

  return unitList;
};
